var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "TasksBank__View", attrs: { dir: "rtl" } },
    [
      _c("EntityListLayout", {
        ref: "list",
        attrs: { tabs: _vm.tabs, namespace: "tasksBank" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_c("h1", [_vm._v("בנק משימות")])]
            },
            proxy: true,
          },
          {
            key: "counter",
            fn: function (slotProps) {
              return [
                _vm._v(' סה"כ '),
                _c("b", [_vm._v(_vm._s(_vm.getTotalRecords(slotProps)) + " ")]),
              ]
            },
          },
          {
            key: "button",
            fn: function () {
              return [
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-primary", "icon-left": "plus" },
                    on: {
                      click: function ($event) {
                        return _vm.openTask()
                      },
                    },
                  },
                  [_vm._v("משימה חדשה")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }